/* eslint-disable */
  // Do not edit this file, it is auto-generated at build time!
  // See scripts/generate-component-factory/index.ts to modify the generation of this file.
  
  import * as CoreCallToAction from 'src/components/Core/CoreCallToAction';
import * as CoreCategoryTabs from 'src/components/Core/CoreCategoryTabs';
import * as CoreContentCards from 'src/components/Core/CoreContentCards';
import * as CoreFeaturedMedia from 'src/components/Core/CoreFeaturedMedia';
import * as CoreForm from 'src/components/Core/CoreForm';
import * as InputField from 'src/components/Core/CoreForm/components/InputField';
import * as SelectDropDown from 'src/components/Core/CoreForm/components/SelectDropDown';
import * as CoreHero from 'src/components/Core/CoreHero';
import * as CoreHeroFeaturedContent from 'src/components/Core/CoreHeroFeaturedContent';
import * as CoreMetadata from 'src/components/Core/CoreMetadata';
import * as CoreNavigationFooter from 'src/components/Core/CoreNavigationFooter';
import * as CoreNavigationHeader from 'src/components/Core/CoreNavigationHeader';
import * as CoreQuoteSlider from 'src/components/Core/CoreQuoteSlider';
import * as CoreRichText from 'src/components/Core/CoreRichText';
import * as CoreSplitCallToAction from 'src/components/Core/CoreSplitCallToAction';
import * as CoreTextBlock from 'src/components/Core/CoreTextBlock';
  
  const components = new Map();
  components.set('CoreCallToAction', CoreCallToAction);
components.set('CoreCategoryTabs', CoreCategoryTabs);
components.set('CoreContentCards', CoreContentCards);
components.set('CoreFeaturedMedia', CoreFeaturedMedia);
components.set('CoreForm', CoreForm);
components.set('InputField', InputField);
components.set('SelectDropDown', SelectDropDown);
components.set('CoreHero', CoreHero);
components.set('CoreHeroFeaturedContent', CoreHeroFeaturedContent);
components.set('CoreMetadata', CoreMetadata);
components.set('CoreNavigationFooter', CoreNavigationFooter);
components.set('CoreNavigationHeader', CoreNavigationHeader);
components.set('CoreQuoteSlider', CoreQuoteSlider);
components.set('CoreRichText', CoreRichText);
components.set('CoreSplitCallToAction', CoreSplitCallToAction);
components.set('CoreTextBlock', CoreTextBlock);
  
  
  function baseComponentFactory(componentName: string) {
    const component = components.get(componentName);
  
    return component?.Default || component?.default || component;
  }
    
  export function componentFactory(componentName: string) {
    return baseComponentFactory(componentName);
  }
  